import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/result/equis.svg'


const _withScopeId = n => (_pushScopeId("data-v-1238c768"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "review-answers" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "review-answers__title" }, "Review Answers", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "review-answers__subtitle" }, "Your Answers", -1))
const _hoisted_6 = { class: "review-answers__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Answer = _resolveComponent("Answer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "review-answers__equis-icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, _hoisted_3),
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answearsQuiz, (answer, index) => {
        return (_openBlock(), _createBlock(_component_Answer, {
          key: index,
          answer: answer,
          question: _ctx.currentQuiz.questions[index]
        }, null, 8, ["answer", "question"]))
      }), 128))
    ])
  ]))
}